import { customFetch } from '@skytech/auth'
import { config } from '@skytech/config'
import { EMAIL_PATTERN } from '@skytech/utils'

import { API_PATH_AUTHENTICATE } from './apiRoutes'

const authFetchConfig = {
  credentials: 'include' as const,
  environment: config.AUTH_API_URL,
}

const authResources = {
  getSettings: ({ phoneNumber, phoneCountryId }: { phoneCountryId: number; phoneNumber: string }) =>
    customFetch<{
      isAccessCodeRequired: boolean
      isPasswordRequired: boolean
      hasMsalLogin: boolean
      phoneCountryId: number
    }>({
      path: `app/authenticate/settings/${phoneCountryId}/${phoneNumber}`,
      ...authFetchConfig,
    }),

  // Mutations
  logIn: async (args: {
    phoneNumberOrEmail: string
    phoneCountryId: number
    password?: string
    accessCode?: string
  }) => {
    const { phoneCountryId, ...payload } = args
    return customFetch<{
      token: string
    }>({
      path: API_PATH_AUTHENTICATE,
      method: 'POST',
      data: { ...payload, countryId: phoneCountryId },
      ...authFetchConfig,
    })
  },
  generatePassword: ({ phoneNumber, countryId }: { phoneNumber: string; countryId: number }) =>
    customFetch<null>({
      path: `app/${countryId}/${phoneNumber}/key/generate`,
      method: 'POST',
      data: {
        sendMail: phoneNumber.match(EMAIL_PATTERN),
      },
    }),
  deleteRefreshToken: () =>
    customFetch<{ token: string }>({
      method: 'DELETE',
      path: 'app/token',
      ...authFetchConfig,
    }),
}

export default authResources
